import { render, staticRenderFns } from "./MyDetails.vue?vue&type=template&id=539b02b5&scoped=true&"
import script from "./MyDetails.vue?vue&type=script&lang=js&"
export * from "./MyDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyDetails.vue?vue&type=style&index=0&id=539b02b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b02b5",
  null
  
)

export default component.exports